import { SearchContextState } from "./types";

export const getDefaultSearchContextState = (): SearchContextState => ({
  searchQuery: null,
});

export default getDefaultSearchContextState;
